<div class="rounded-md border border-slate-700 bg-slate-800/40 p-2">
  <div class="mb-1 text-xs font-semibold text-slate-200">{{ view().title || 'Positions' }}</div>
  @if (view().rows.length === 0) {
    <div class="text-xs text-slate-400">No positions provided.</div>
  } @else {
    <div class="overflow-x-auto">
      <table class="w-full text-left text-xs">
        <thead>
          <tr class="text-slate-400">
            <th class="py-1 pr-2 font-medium">Symbol</th>
            <th class="py-1 pr-2 font-medium">Qty</th>
            <th class="py-1 pr-2 font-medium">Avg</th>
            <th class="py-1 pr-2 font-medium">Mkt value</th>
            <th class="py-1 font-medium">uPnL</th>
          </tr>
        </thead>
        <tbody>
          @for (r of view().rows; track $index) {
            <tr class="border-t border-slate-700/60 text-slate-200">
              <td class="py-1 pr-2 font-mono">{{ r.symbol }}</td>
              <td class="py-1 pr-2">{{ r.quantity }}</td>
              <td class="py-1 pr-2">{{ r.avgPrice }}</td>
              <td class="py-1 pr-2">{{ r.marketValue }}</td>
              <td class="py-1">{{ r.unrealizedPnl }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
